import { Box } from "@chakra-ui/react";
import {
  colors,
  getCdnImageSrc,
  HStack,
  Image,
  LazyLoadYoutube,
  NextLink,
  responsive,
  VStack,
} from "goi_common";
import React from "react";

function tagTypeToClassName(tag: string) {
  if (tag === "h2") return "subtitle_21_sb md_head_24_sb gray900";
  if (tag === "h3") return "subtitle_18_sb md_subtitle_21_sb gray900";
  if (tag === "h4") return "subtitle_16_b md_subtitle_18_b gray900";
  if (tag === "aside") return "body_16_r gray900";
  if (tag === "chip") return "caption_12_sb gray900";
  if (tag === "img") return "";
  return "body_16_r md_body_18_r gray900";
}
export default function GuideContent({
  contents,
  isFeed,
}: {
  contents: any;
  isFeed?: boolean;
}) {
  return (
    <VStack gap="40px">
      {contents.map((res: any, i: number) => {
        if (res.type === "img") {
          return (
            <VStack
              key={res.type + "-" + i}
              width="100%"
              alignItems="center"
              padding={isFeed ? "0 20px" : "0"}
            >
              <Image
                css={
                  isFeed
                    ? responsive({
                        maxWidth: { base: "100%", md: "480px" },
                        margin: { base: "0", md: "20px" },
                      })
                    : { maxWidth: "100%" }
                }
                src={getCdnImageSrc(res.resource)}
                alt={res.imgAlt}
              />
              {res.description && (
                <Box
                  className="caption_12_m gray900"
                  css={responsive({ marginTop: { base: "0px", md: "-10px" } })}
                >
                  {res.description}
                </Box>
              )}
            </VStack>
          );
        }
        if (res.type === "ul") {
          return (
            <ul
              key={res.type + "-" + i}
              css={{ display: "flex", flexDirection: "column", gap: "30px" }}
            >
              {res.resource.map((ulList: string, index: number) => (
                <Box
                  css={responsive({ padding: { base: "0 24px", md: "0" } })}
                  className={tagTypeToClassName(res.type)}
                  key={"li" + i + "-" + index}
                  as={"li"}
                  whiteSpace="pre-line"
                  dangerouslySetInnerHTML={{ __html: ulList }}
                />
              ))}
            </ul>
          );
        }
        if (res.type === "youtube") {
          return (
            <LazyLoadYoutube key={res.type + "-" + i} src={res.resource} />
          );
        }
        if (res.type === "a") {
          return (
            <NextLink
              key={res.type + "-" + i}
              css={responsive({
                background: colors.brown500,
                padding: "16px",
                borderRadius: "10px",
                textAlign: "center",
                margin: { base: "10px 24px", lg: "20px 0" },
              })}
              className="white subtitle_16_sb"
              href={res.href}
              event={{
                newGtm: res.newGtm,
              }}
            >
              {res.resource}
            </NextLink>
          );
        }
        if (res.type === "aside") {
          return (
            <Box
              css={responsive({
                padding: { base: "20px 24px", md: "20px" },
                margin: { base: "0 20px", md: "0" },
                background: colors.warmGray150,
                borderRadius: "10px",
              })}
              className={tagTypeToClassName(res.type)}
              key={res.type + "-" + i}
              as={res.type}
              whiteSpace="pre-line"
              dangerouslySetInnerHTML={{ __html: res.resource }}
            />
          );
        }
        if (res.type === "chip") {
          return (
            <HStack
              key={res.type + "-" + i}
              gap="6px"
              css={responsive({
                marginTop: { base: "-30px", md: "-26px" },
                padding: { base: "0 24px", md: "0" },
              })}
            >
              {res.resource.map((list: string, index: number) => (
                <Box
                  className={tagTypeToClassName(res.type)}
                  css={{
                    background: colors.brown100,
                    padding: "4px 6px",
                    borderRadius: "5px",
                  }}
                  key={"li" + i + "-" + index}
                  as={"p"}
                  dangerouslySetInnerHTML={{ __html: list }}
                />
              ))}
            </HStack>
          );
        }
        return (
          <Box
            css={responsive({
              padding: { base: "0 24px", md: "0" },
              margin:
                res.type === "h3" || res.type === "h4" ? "10px 0 -30px" : "0",
            })}
            className={tagTypeToClassName(res.type)}
            key={res.type + "-" + i}
            as={res.type}
            whiteSpace="pre-line"
            dangerouslySetInnerHTML={{ __html: res.resource }}
          />
        );
      })}
    </VStack>
  );
}
